import React, { useState } from 'react';
import Comps from '@owenscorning/react-library';
import { connect } from 'react-redux';
import { setAppData } from '../WarrantyTransferForm/redux/actions';

const FileWidget = Comps.Connect.FileWidget

const ReduxFileWidget = ({ onChange, setAppData, fileUploadState={} }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [fileSize, setFileSize] = useState(0);

  const args = {
    areControlsReadonly: false,
    server: MDMS_URL,
  }

  const onFailure = () => console.log('upload failure');

  const saveFileUploadState = state => {
    setAppData({ fileUploadState: state });
  }

  const areControlsReadonly = args.areControlsReadonly;

  return(
    <FileWidget
      multiple
      server={args.server}
      onChange={onChange}
      onChangeSize={setFileSize}
      saveFileUploadState={saveFileUploadState}
      fileUploadState={fileUploadState}
      value={['non-empty array']}
      onIsUploading={setIsUploading}
      onFailure={onFailure}
      readOnly={areControlsReadonly}
      mimeTypes={[
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/tiff',
        'image/gif',
        'image/heic',
      ]}
      track={{}}
    />
  )
};
const mapStateToProps = state => (
  {
    appData: state.appData,
  }
);


const mapDispatchToProps = dispatch => (
  {
    setAppData: hash => dispatch(setAppData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxFileWidget);
